import { BaseCustomElement, Toast } from "brut-js"
import { AjaxSubmit } from "brut-js"

class PlanEditorComponent extends BaseCustomElement {
  static tagName = "cc-plan-editor-component"
  static observedAttributes = [
    "show-warnings",
    "plan-state",
    "just-updated",
  ]

  static selectorForDate(date) {
    return `${this.tagName}[plan-date="${date}"]`
  }

  #mutationObserver = null

  planStateChangedCallback({newValue}) {
    // Ignore - this is here just to satisfy BaseCustomElement
  }

  justUpdatedChangedCallback({newValueAsBoolean}) {
    // Ignore - this is here just to satisfy BaseCustomElement
  }

  constructor() {
    super()
    this.#mutationObserver = new MutationObserver( () => this.update() )
  }

  onDisconnected() {
    this.#mutationObserver.disconnect()
  }

  onConnected() {
    this.#mutationObserver.observe(this, { childList: true, subtree: true })
  }

  #okListener = (event) => {
    const parent = event.target.closest(PlanEditorComponent.tagName)
    if (parent === this) {
      const replacement = event.detail.querySelector(PlanEditorComponent.tagName)
      if (replacement) {
        const toast = replacement.querySelector(Toast.tagName)
        for (const attribute of replacement.attributes) {
          this.setAttribute(attribute.name, attribute.value)
        }
        this.removeAttribute("just-updated")
        this.replaceChildren(...replacement.childNodes)
        this.setAttribute("just-updated", "true")
        if (toast) {
          toast.scrollIntoView({ behavior: "smooth", block: "center" })
        }
        this.dispatchEvent(new CustomEvent("cc:planupdated"))
      }
      else {
        console.warn("Response had no %s, so not sure what to do",PlanEditorComponent.tagName)
      }
    }
  }
  #toggleDetails = (event) => {
    const details = this.querySelector("details")
    if (!details) {
      this.logger.warn("No details founds, cannot toggle on click")
      return
    }
    event.preventDefault()
    if (details.open) {
      details.removeAttribute("open")
    }
    else {
      details.setAttribute("open", "true")
    }
  }

  #preventSummaryFromClosingOnSafariWhenSpaceEnteredInInput = (event) => {
    const activeElement = document.activeElement
    if (activeElement) {
      const summary = event.currentTarget
      if (summary.tagName === "SUMMARY") {
        const isTextArea = activeElement.tagName === "TEXTAREA"
        const isInput = activeElement.tagName === "INPUT"
        const isNotSubmitInput = isInput && activeElement.getAttribute("type") !== "submit"

        const activeElementInsideSummary = summary.contains(activeElement)
        const activeElementIsInputOrTextArea = isTextArea || isNotSubmitInput
        if (activeElementInsideSummary && activeElementIsInputOrTextArea) {
          event.preventDefault()
        }
      }
      else {
        this.logger.warn("Expected event.currentTarget to be a summary, but it was %s", summary.tagName)
      }
    }
    else {
      this.logger.warn("No active element found, cannot prevent summary from closing on Safari when space entered in input")
    }
  }

  update() {
    this.querySelectorAll(AjaxSubmit.tagName).forEach( (ajaxSubmit) => {
      ajaxSubmit.addEventListener("brut:submitok", this.#okListener)
    })
    this.querySelectorAll("[data-plan-title]").forEach( (element) => {
      element.addEventListener("click", this.#toggleDetails)
    })
    this.querySelectorAll("summary").forEach( (summary) => {
      summary.addEventListener("click", this.#preventSummaryFromClosingOnSafariWhenSpaceEnteredInInput)
    })
  }
}
export default PlanEditorComponent
